var _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBannerImg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "svg72",
    width: 672,
    height: 380,
    viewBox: "0 0 675 380",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs4"
  }, /*#__PURE__*/React.createElement("style", {
    id: "style2"
  }, ".a{fill:#21549b;opacity:.529}.d,.e,.f{fill:#fff}.e{opacity:.548}.f{opacity:.55}"))), /*#__PURE__*/React.createElement("g", {
    id: "g70",
    transform: "translate(0 10.045)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g68",
    transform: "translate(-17.641 19.723)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path6",
    d: "M-8.176 588.18C-12.764 619.1-1.2 569.479 7.849 574.6c45.959 25.995 234.592-185.11 297.012-381.422C379.437-41.367 197.914 5.589 81.934-1.4c-1.293.494-62.215 401.6-90.11 589.58",
    className: "a",
    style: {
      opacity: 0.52899996,
      fill: "#21549b"
    },
    transform: "rotate(-98.97 228.51 174.995)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M213.86 554.435c5.374 188.38-341.412-108.135-176.689-407.367s216.356-60.353 307.177-79.621c.964.358-135.813 300.304-130.488 486.988",
    style: {
      opacity: 0.36700027,
      fill: "#21549b"
    },
    transform: "rotate(75 313.546 393.113)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path10",
    d: "M0 288.208c128.768 139.11 158.6-50.45 223.842-226.084s-44.518 77.944-160.068 68.236c-.357.091 33.882-42.134 28.073-4.426C76.994 222.339 14.8 186.273 0 288.208",
    className: "a",
    style: {
      opacity: 0.52899996,
      fill: "#21549b"
    },
    transform: "rotate(-112 336.674 66.7)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "g66",
    transform: "translate(46.609 64.377)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path12",
    d: "M13.878 286.116c-6.642-9.241-11.067-18.549-12.561-27.839A109 109 0 0 1 0 244.9v-7.822C4.4 115.547 212.863 16.5 375.236 1.278c171.722-16.1 246.933 122.8 268 253.848q2.583 16.065 3.885 30.989z",
    style: {
      fill: "#21549b"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "g54",
    transform: "translate(39.39 27.432)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "circle14",
    cx: 5.957,
    cy: 5.957,
    r: 5.957,
    className: "d",
    style: {
      fill: "#fff"
    },
    transform: "translate(407.995 43.878)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle16",
    cx: 5.957,
    cy: 5.957,
    r: 5.957,
    className: "d",
    style: {
      fill: "#fff"
    },
    transform: "translate(348.701 136.679)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path18",
    d: "M103.539 98.366V42.77a31.77 31.77 0 1 0-63.539 0v55.6a31.77 31.77 0 1 0 63.539 0zM71.77 18.942A23.846 23.846 0 0 1 95.6 42.77V66.6H47.942V42.77A23.846 23.846 0 0 1 71.77 18.942m0 103.251a23.846 23.846 0 0 1-23.828-23.827V74.539H95.6v23.827a23.846 23.846 0 0 1-23.83 23.828z",
    className: "d",
    style: {
      fill: "#fff"
    },
    transform: "translate(365.513 72.163)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path20",
    d: "M80.045 34.12a31.7 31.7 0 0 0-22.477 9.253L18.253 82.688a31.787 31.787 0 0 0 44.954 44.954l39.315-39.315A31.75 31.75 0 0 0 80.045 34.12M57.568 122a23.812 23.812 0 0 1-33.676-33.673L40.73 71.489 74.445 105.2Zm39.315-39.312L80.045 99.526 46.329 65.81l16.838-16.838a23.84 23.84 0 0 1 33.716 33.716",
    className: "d",
    style: {
      fill: "#fff"
    },
    transform: "translate(-9 87.751)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path22",
    d: "M57.216 110.174a37.61 37.61 0 0 0 52.959 0 37.44 37.44 0 0 0 0-52.912L63.859 10.947A37.431 37.431 0 0 0 10.9 63.859Zm46.315-6.643a28.123 28.123 0 0 1-39.672 0L44.023 83.7l39.719-39.724 19.836 19.836a28.166 28.166 0 0 1-.047 39.719M17.544 17.544a28.123 28.123 0 0 1 39.672 0L77.052 37.38 37.333 77.1 17.5 57.263a28.237 28.237 0 0 1 .047-39.719z",
    className: "d",
    style: {
      fill: "#fff"
    },
    transform: "translate(172.41 45.031)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path24",
    d: "M36.911 53.827a3.971 3.971 0 0 0 0-7.942H25V33.971a3.971 3.971 0 0 0-7.942 0v11.914H5.141a3.971 3.971 0 0 0 0 7.942h11.914v11.914a3.971 3.971 0 0 0 7.942 0V53.827Z",
    className: "d",
    style: {
      fill: "#fff"
    },
    transform: "translate(164.967 138.865)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path26",
    d: "m71.137 65.187 8.419-8.419a3.96 3.96 0 0 0-5.6-5.6l-8.419 8.419-8.419-8.419a3.96 3.96 0 0 0-5.6 5.6l8.419 8.419-8.419 8.419a3.955 3.955 0 0 0 0 5.6 3.9 3.9 0 0 0 2.82 1.152 4.07 4.07 0 0 0 2.82-1.152l8.419-8.419L74 79.206a3.9 3.9 0 0 0 2.82 1.152 4.07 4.07 0 0 0 2.82-1.152 3.955 3.955 0 0 0 0-5.6z",
    className: "d",
    style: {
      fill: "#fff"
    },
    transform: "translate(483.233 122.574)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle28",
    cx: 9.363,
    cy: 9.363,
    r: 9.363,
    className: "e",
    style: {
      opacity: 0.54799996,
      fill: "#fff"
    },
    transform: "translate(272.143 13.79)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle30",
    cx: 15.154,
    cy: 15.154,
    r: 15.154,
    className: "e",
    style: {
      opacity: 0.54799996,
      fill: "#fff"
    },
    transform: "translate(270.728 199.195)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path32",
    d: "M20.617 42.965a2.161 2.161 0 0 0 0-4.322h-6.482v-6.482a2.161 2.161 0 0 0-4.322 0v6.482H3.331a2.161 2.161 0 0 0 0 4.322h6.482v6.482a2.161 2.161 0 1 0 4.322 0v-6.482z",
    className: "f",
    style: {
      opacity: 0.55,
      fill: "#fff"
    },
    transform: "translate(336.586 49.362)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path34",
    d: "M19.447 12.965a2.161 2.161 0 0 0 0-4.322h-6.482V2.161a2.161 2.161 0 0 0-4.322 0v6.482H2.161a2.161 2.161 0 0 0 0 4.322h6.482v6.482a2.161 2.161 0 1 0 4.322 0v-6.482z",
    className: "f",
    style: {
      opacity: 0.55,
      fill: "#fff"
    },
    transform: "rotate(-45 131.33 -73.363)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle36",
    cx: 13.791,
    cy: 13.791,
    r: 13.791,
    className: "e",
    style: {
      opacity: 0.54799996,
      fill: "#fff"
    },
    transform: "translate(471.808 50.189)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path38",
    d: "M10.648 7.1a1.183 1.183 0 0 0 0-2.366H7.1V1.183a1.183 1.183 0 0 0-2.366 0v3.549H1.183a1.183 1.183 0 0 0 0 2.366h3.549v3.549a1.183 1.183 0 1 0 2.366 0V7.1Z",
    className: "f",
    style: {
      opacity: 0.55,
      fill: "#fff"
    },
    transform: "rotate(45 -38.953 519.418)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle40",
    cx: 2.891,
    cy: 2.891,
    r: 2.891,
    className: "f",
    style: {
      opacity: 0.55,
      fill: "#fff"
    },
    transform: "translate(143.633 215.38)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle42",
    cx: 2.891,
    cy: 2.891,
    r: 2.891,
    className: "f",
    style: {
      opacity: 0.55,
      fill: "#fff"
    },
    transform: "translate(369.117)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle44",
    cx: 4.935,
    cy: 4.935,
    r: 4.935,
    className: "e",
    style: {
      opacity: 0.54799996,
      fill: "#fff"
    },
    transform: "translate(343.175 33.546)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle46",
    cx: 2.891,
    cy: 2.891,
    r: 2.891,
    className: "f",
    style: {
      opacity: 0.55,
      fill: "#fff"
    },
    transform: "translate(382.493 218.786)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle48",
    cx: 2.891,
    cy: 2.891,
    r: 2.891,
    className: "f",
    style: {
      opacity: 0.55,
      fill: "#fff"
    },
    transform: "translate(369.117)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle50",
    cx: 2.891,
    cy: 2.891,
    r: 2.891,
    className: "f",
    style: {
      opacity: 0.55,
      fill: "#fff"
    },
    transform: "translate(194.271 23.162)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle52",
    cx: 2.891,
    cy: 2.891,
    r: 2.891,
    className: "f",
    style: {
      opacity: 0.55,
      fill: "#fff"
    },
    transform: "translate(224.846 237.861)"
  })), /*#__PURE__*/React.createElement("circle", {
    id: "circle56",
    cx: 5.957,
    cy: 5.957,
    r: 5.957,
    className: "f",
    style: {
      opacity: 0.55,
      fill: "#fff"
    },
    transform: "translate(144.79 256.601)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle58",
    cx: 5.957,
    cy: 5.957,
    r: 5.957,
    className: "f",
    style: {
      opacity: 0.55,
      fill: "#fff"
    },
    transform: "translate(53.091 147.019)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle60",
    cx: 5.957,
    cy: 5.957,
    r: 5.957,
    className: "f",
    style: {
      opacity: 0.55,
      fill: "#fff"
    },
    transform: "translate(581.172 268.182)"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "circle62",
    cx: 2.891,
    cy: 2.891,
    r: 2.891,
    className: "f",
    style: {
      opacity: 0.55,
      fill: "#fff"
    },
    transform: "translate(565.652 136.428)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path64",
    d: "M14.289 9.526a1.588 1.588 0 0 0 0-3.175H9.526V1.588a1.588 1.588 0 0 0-3.175 0V6.35H1.588a1.588 1.588 0 0 0 0 3.175H6.35v4.763a1.588 1.588 0 1 0 3.175 0V9.526Z",
    className: "f",
    style: {
      opacity: 0.55,
      fill: "#fff"
    },
    transform: "rotate(-90 376.011 -102.534)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBannerImg);
export default __webpack_public_path__ + "static/media/bannerImg.2511b4442c5d6b431a8619337078f66c.svg";
export { ForwardRef as ReactComponent };